import { Permission } from 'app/enums';

export type AuthenticatedUser = {
    userId: string;
    customerId: string;
    fullname: string;
    permissions: Permission[];
    username: string;
    inbox: string;
};
